import Actividad from "../models/Actividad";
import Enlace from "../models/Enlace";
import Imagen from "../models/Imagen";

function generarActividad1() {

    const descripcionesAct1: string[] = [
        "A finales de septiembre comienza la Berra.",
        "¿Aún no sabes lo que es?",
        "La berrea o también llamada brama es la época de celo de los ciervos. Un profundo bramido es emitido por los ciervos machos para dominar su territorio y que los demás no se acerquen a sus hembras.",
        "Las bramas, luchas y carreras de los grandes machos hacen de esto un espectáculo impresionante para los amantes de la naturaleza.",
        "¿Te vienes a disfrutarla con nosotros?"
    ];

    const imagenesAct1: Imagen[] = [
        new Imagen("./img/sections/act1.jpg",""),
        new Imagen("./img/sections/act1-1.jpg",""),
        new Imagen("./img/sections/act1-2.jpg",""),
        new Imagen("./img/sections/act1-3.jpg","")
    ];

    const enlacesInteres: Enlace[] = [
        new Enlace("Mejores enclaves de nuestro amigo Drakis", "https://drakis.net/2022/09/07/los-5-mejores-enclaves-de-berrea-en-la-sierra-de-albarracin/"),
        new Enlace("El desmogue de los ciervos", "https://drakis.net/2022/05/06/el-desmogue-de-los-ciervos/"),
        new Enlace("Tiempo de Berrea", "https://drakis.net/2017/10/11/tiempo-de-berrea/")
    ]

    return  new Actividad("modalActividad1", "La Berrea", descripcionesAct1 , "img/icons/ciervo.png", "IMG", imagenesAct1, undefined, undefined, enlacesInteres);

}

function generarActividad2() {

    const descripcionesAct2: string[] = [
        "La Sierra de Albarracín (Teruel) se ha caracterizado siempre por la riqueza de setas en sus bosques.",
        "Aquí es fácil encontrar diferentes tipos de setas en primavera y en otoño, que también se pueden degustar en la zona."        
    ];

    const imagenesAct2: Imagen[] = [
        new Imagen("./img/sections/act2.jpg", ""),
        new Imagen("./img/sections/act2-1.jpg", ""),
        new Imagen("./img/sections/act2-2.jpg", ""),
        new Imagen("./img/sections/act2-3.jpg", "")
    ];

    const elementosListaAct2: string[] = [
        "Protege el bosque, y no remuevas el suelo. Están prohibidos los rastrillos y azadas.",
        "Coge solo las setas que sepas identificar y vayas a consumir.",
        "Utiliza siempre una cesta que deje salir las esporas.",
        "Recoge la basura que traigas contigo y a ser posible, la que encuentres a tu paso."
    ];

    const enlacesInteres: Enlace[] = [
        new Enlace("Parque micológico Comunidad De Albarracín", "https://micologiaalbarracin.es/"),
        new Enlace("Turismo Sierra De Albarracín", "https://albarracinturismo.com/micologia-setas/"),
        new Enlace("Micológia - Albarracín Love", "https://albarracinlove.com/setas-albarracin/")        
    ];

    return new Actividad("modalActividad2", "Micología", descripcionesAct2, "img/icons/seta.png", "IMG", imagenesAct2, "Si vienes a disfrutar a nuestros bosques y recolectar setas debes tener en cuenta siempre la normativa actual:", elementosListaAct2, enlacesInteres);

}

function generarActividad3() {

    const descripcionesAct3: string[] = [
        "Griegos es Destino Turístico Starlight, estos son lugares visitables con excelentes cualidades para contemplar los cielos estrellados, ya que están protegidos de la contaminación lumínica.",
        "Además la Sierra de Albarracín también tiene el certificado de Reserva Starlight.",
        "Existe una red de miradores astronómicos, aquí en Griegos está situado en la Ermita de San Roque. ¿Quieres saber dónde esta el resto?",
        "¡Ven y te lo contamos!"
    ];

    const imagenesAct3: Imagen[] = [
        new Imagen("./img/sections/act3.jpg", "")
    ];

    const enlacesInteres: Enlace[] = [
        new Enlace("Turismo Sierra De Albarracín", "https://albarracinturismo.com/la-sierra-de-albarracin-logra-el-reconocimiento-internacional-como-reserva-y-destino-starlight/"),
        new Enlace("Turismo Astronómico - Albarracín Love", "https://albarracinlove.com/turismo-astronomico-en-albarracin/")        
    ]   
    

    return new Actividad("modalActividad3", "Destino StarLight", descripcionesAct3, "/img/icons/estrellas.png", "IMG", imagenesAct3, undefined, undefined, enlacesInteres)

}

function generarActividad4() {

    const descripcionesAct4: string[] = [
        "¿Te gusta el senderismo y buscas rutas que hacer?  ¡LO TENEMOS!",
        "En esta zona encontraras numerosas rutas que recorren un entorno natural espectacular. Senderos que te harán disfrutar de nuestros bosques y paisajes únicos, al mismo tiempo que observas una gran variedad de animales.",
        "Próximamente publicaremos tracks en nuestra página web, ¡de momento te dejamos por aquí un botón para que le eches un vistazo a algunos recorridos!"
    ];

    const imagenesAct4: Imagen[] = [
        new Imagen("./img/sections/act/act40.jpg", ""),
        new Imagen("./img/sections/act/act41.jpg", ""),
        new Imagen("./img/sections/act/act42.jpg", ""),
        new Imagen("./img/sections/act/act43.jpg", ""),
        new Imagen("./img/sections/act/act44.jpg", ""),
        new Imagen("./img/sections/act/act45.jpg", ""),
        new Imagen("./img/sections/act/act46.jpg", "")
    ];

    return new Actividad("modalActividad4", "Rutas Senderistas", descripcionesAct4, "fa-solid fa-person-walking", "ICO", imagenesAct4)

}

function generarActividad5() {

    const descripcionesAct5: string[] = [
        "¿Eres amante de las bicis?",
        "La Sierra de Albarracín te ofrece un montón de pistas de tierra donde disfrutar y perderte pedaleando por la zona.",
        "Los alrededores de Griegos son ideales para practicar deporte de alto rendimiento gracias a su altura, 1600 metros.",
        "Y qué me dices de Montañas Vacías, ¿has oído hablar de esta aventura?",
        "Su intención es dar a conocer la Laponia Española a través de una ruta bikepacking, tomando Teruel como punto de partida, recorriendo los Montes Universales, la sierra de Javalambre y la sierra de Gudar por caminos y pistas forestales. ¡Es todo un desafío!"
    ];

    const imagenesAct5: Imagen[] = [
        new Imagen("./img/sections/act/act50.jpg", ""),
        new Imagen("./img/sections/act/act51.jpg", ""),
        new Imagen("./img/sections/act/act52.jpg", ""),
        new Imagen("./img/sections/act/act53.jpg", "")
    ];

    const enlacesInteres: Enlace[] = [
        new Enlace("Montañas Vacías", "https://montanasvacias.com/")
    ]

    return new Actividad("modalActividad5", "Rutas Ciclistas", descripcionesAct5, "fa-solid fa-bicycle", "ICO", imagenesAct5, undefined, undefined, enlacesInteres)

}

export const getActividades = () => {
    
    const actividades: Actividad[] = [
        generarActividad1(),
        generarActividad2(),
        generarActividad3(),
        generarActividad4(),
        generarActividad5()       
    ];

    return actividades

} 